export default "__VITE_ASSET__Cq5JjLvg__"